import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
    return (
        <div className="mx-auto max-w-lg px-6 py-24 text-center">
            <h1 className="font-heading text-3xl font-bold">Payment cancelled</h1>
            <p className="text-muted-foreground mt-2">No worries — your seat wasn't locked. You can try again anytime.</p>
            <div className="mt-6 flex justify-center gap-2">
                <Link to="/centers"><Button className="rounded-sm bg-primary hover:bg-primary/90">Back to centers</Button></Link>
                <Link to="/my-bookings"><Button variant="outline" className="rounded-sm">My Bookings</Button></Link>
            </div>
        </div>
    );
}
